import { ref } from 'vue';

import type { BillingCustomerState, BillingPlan, BillingSubscriptionState } from '@/services/models';

export const createBillingModule = () => {
  const billing = ref<BillingSubscriptionState>({} as BillingSubscriptionState);

  const billingPlans = ref<BillingPlan[]>([]);

  const billingAddons = ref<Record<string, unknown>>({});

  const billingCustomer = ref<BillingCustomerState | null>(null);

  const appError = ref('');

  const setBilling = (value: BillingSubscriptionState) => {
    billing.value = value;
  };

  const setBillingPlans = (value: BillingPlan[]) => {
    billingPlans.value = value;
  };

  const setBillingAddons = (value: Record<string, unknown>) => {
    billingAddons.value = value;
  };

  const setBillingCustomer = (value: BillingCustomerState | null) => {
    billingCustomer.value = value;
  };

  const reset = () => {
    billing.value = {} as BillingSubscriptionState;

    billingPlans.value = [];

    billingAddons.value = {};

    billingCustomer.value = null;

    appError.value = '';
  };

  return {
    state: {
      billing,
      billingPlans,
      billingAddons,
      billingCustomer,
      appError,
      setBilling,
      setBillingPlans,
      setBillingAddons,
      setBillingCustomer,
    },
    reset,
  };
};
